import {
  gridSizeMdLg2,
  gridSizeMdLg12,
  gridSizeMdLg4,
  formatDate,
  hasPermission,
} from "@/shared"
import { IDataMovimientoInventario } from "@/shared/interfaces"
import { Button, Grid } from "@mui/material"
import { GeneralTable } from "@/shared/components/ui"
import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker"
import { Refresh, Search } from "@mui/icons-material"
import DeleteIcon from '@mui/icons-material/Delete';
import useKardexByBodega from "../hook/useKardeByBodega"
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm"
import { IDataSerie } from "@/shared/interfaces/erp/administration/productofactorserie.interface"
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch"
import { PermissionsEnum } from "@/auth/interfaces"
import { PiMicrosoftExcelLogoFill } from "react-icons/pi"

export default function KardexPorSerie() {


  const {
    form,
    setEnabled,
    enabled,
    flatpickrRef,
    setFilterObject,
    columnBase,
    dataKardex,
    isLoadingKardex,
    isRefetchingKardex,
    pagination,
    setPagination,
    columnFilters,
    setColumnFilters,
    downloadKardexExcel,
    refetch
  } = useKardexByBodega()

  const {
    fetchAutocompleteSerie
  } = useAutocompleteFetch()

  const {
    control,
    reset
  } = form



  return (
    <Grid container spacing={3}
      justifyContent={'end'}
    //alignItems={'center'}
    >


      <Grid item
        container
        {...gridSizeMdLg12}
        spacing={3}>

        <CustomAutocompleteFetchForm<IDataSerie>
          required={false}
          control={control}
          size={gridSizeMdLg4}
          name="serie"
          label="Buscar por serie o MAC"
          fetchData={fetchAutocompleteSerie}
          //isAll={true}
          getOptionLabel={(opt) => opt.serie || ''}
          key={'autocomplete-serie'}
          getOptionKey={(o) => o.serie!}
          keySearch="serie"
          onChangeValue={(e) => {
            setEnabled(false);

            reset({
              ...form.getValues(),
              serie: e as string
            })


          }}
        />

        <DateRangePicker
          size={gridSizeMdLg4}
          flatpickrRef={flatpickrRef}
          defaultValue={[form.getValues().fecha_creacion_after, form.getValues().fecha_creacion_before]}
          onChange={(range) => {
            console.log(range);
            setEnabled(false);

            if (range.length == 2) {
              reset({
                ...form.getValues(),
                fecha_creacion_after: formatDate(range[0]),
                fecha_creacion_before: formatDate(range[1])
              })

            }

          }}
        />

      </Grid>


      <Grid item {...gridSizeMdLg2}>
        <Button
          fullWidth
          size="small"
          disabled={!!!form.getValues('serie')}
          variant="contained"
          startIcon={<Search />}
          onClick={() => {

            reset({
              ...form.getValues(),
              estado: true
            })

            setEnabled(true)
          }}
        >
          Buscar
        </Button>
      </Grid>

      <Grid item {...gridSizeMdLg2}>
        <Button
          fullWidth
          size="small"
          variant="outlined"
          startIcon={<DeleteIcon />}
          onClick={() => {
            reset({
              estado: false
            })
            setFilterObject({})

            setEnabled(false)

            flatpickrRef.current?.flatpickr.clear();

          }}
        >
          Limpiar
        </Button>

      </Grid>

      <Grid item {...gridSizeMdLg2}>
        <Button
          fullWidth
          size="small"
          variant="outlined"
          startIcon={<Refresh />}
          onClick={() => {
            refetch()
          }}
        >
          Actualizar
        </Button>
      </Grid>

      {
        hasPermission(PermissionsEnum.reporte_stock_actual_descargar_excel) &&
        <Grid item {...gridSizeMdLg2}>
          <Button
            size="small"
            fullWidth
            startIcon={<PiMicrosoftExcelLogoFill />}
            variant="contained"
            color="success"
            onClick={() => {
              downloadKardexExcel()
            }}
          >
            EXCEL
          </Button>
        </Grid>
      }

      <Grid item {...gridSizeMdLg12}>

        <GeneralTable<IDataMovimientoInventario>
          columns={columnBase}
          data={enabled
            ? dataKardex?.data.data || []
            : []}
          //
          isLoading={isLoadingKardex}
          isRefetching={isRefetchingKardex}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={dataKardex?.data?.count}
          // // actions
          actionsColumnSize={120}

          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          enableColumnActions={true}

          // crud
          enableEditing={false}
          positionActionsColumn='first'
        />
      </Grid>

    </Grid>
  )

}